// main.js

import Vue from 'vue';
import App from './App';
import { setupCalendar } from 'v-calendar';
import router from './router';
import store from './stores/index';
import './plugins/vcalendar.plugin';
import { mapState } from 'vuex';
import moment from 'moment';
import './plugins/translate.plugin';
import Select2 from 'v-select2-component';
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import './directives';
import './filters';
import { ErrorManager } from './helpers/field-error';
import VueLazyload from 'vue-lazyload';
import VueScrollTo from 'vue-scrollto';
import VueMeta from 'vue-meta';

Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
});

Vue.use(VueLazyload, {
  preLoad: 1,
  error: '/static/img/default/room.png',
  loading: '/static/img/default/loader.svg',
  attempt: 3,
  throttleWait: 1000
});
Vue.use(VueScrollTo);

Vue.component('vue-phone-number-input', VuePhoneNumberInput);
Vue.component('v-select', Select2);
setupCalendar({
  componentPrefix: 'v',
});
Vue.config.productionTip = false;

/* eslint-disable no-new */
async function initializeAndMount() {
  try {
    // 🚨 On initialise TOUT ici, en s'assurant que chaque étape est complétée
    await store.dispatch('client/init');
    await store.dispatch('lang/fetch');
    await store.dispatch('shoppingCart/init', { lang: store.state.lang.currentLang });
    await store.dispatch('search/process', { runAuto: true });

    store.commit('SET_API_STATUS', true);

    // Une fois que tout est prêt, on crée l'instance Vue
    new Vue({
      el: '#app',
      router,
      store,
      components: { App },
      template: '<App />',
      created() {
        ErrorManager.setTranslateMethod(this.$t);
        moment.locale(this.$store.state.lang.currentLang);
      },
      computed: mapState({
        loading: state => state.lang.loading,
      }),
    });

  } catch (e) {
    if (e.response === undefined) {
      store.commit('SET_API_STATUS', false);
    }
  }
}

// Lancement de la fonction d'initialisation
initializeAndMount();

window.routeRGPD = function () {
  let routeData = router.resolve({name: 'privacy'});
  window.open(routeData.href, '_blank');
};

window.openModal = function (v) {
  store.commit('legalModal/SET_TAB', v);
  store.commit('legalModal/OPEN_MODAL');
};



// WEBPACK FOOTER //
// ./src/main.js